import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import "firebase/compat/storage";
const bqExportData = async function(groupId, startDate, endDate, uid) {
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');
    let prefixFileName = `group-${groupId}-`;
    let addition = '';
    if( uid != undefined ){
        prefixFileName = prefixFileName + uid + '-';
        addition = ` and GM.uid = '${uid}'`;
    }
    // const downloadUrl = `https://storage.googleapis.com/thaisook_bigquery_export/${prefixFileName}-000000000000.csv`;
    const result = await queryThaisookViewBigQuery({
        info: 'get group report',
        query: `
        EXPORT DATA OPTIONS (
            uri='gs://thaisook_bigquery_export/${prefixFileName}*.csv',
            format='CSV',
            overwrite=true,
            header=true,
            field_delimiter=','
        ) AS (
        with groupMemberData as (
            SELECT 
                U.uid,
                U.firstname,
                U.lastname,
                U.pictureUrl,
                U.birthdate,
                U.gender,
                U.height,
                G.groupId,
                G.name
            FROM 
                thaisook_view.group_members GM
                left join thaisook_view.users U
                on GM.uid = U.uid 
                left join thaisook_view.groups G
                    on GM.groupId = G.groupId
            where 
                G.groupId = '${groupId}'
                ${addition}
            ),
            memberHealthdata as (
            select 
                date(HD.date) recordDate,
                time(HD.date) recordTime,

                GM.firstname,
                GM.lastname,
                GM.birthdate,
                GM.gender,
                GM.height,
                GM.uid,

                GM.groupId groupId,
                GM.name groupName,
                
                HD.category,
                CAST(NULL as string) source,

                HD.pressureUpper,
                HD.pressureLower,
                HD.hr,
                HD.weight,
                HD.bmi,
                HD.rightArmFat,
                HD.leftArmFat,
                HD.rightLegFat,
                HD.leftLegFat,
                HD.trunkFat,
                HD.bodyFat,
                HD.visceralFat,
                HD.muscle,
                HD.waist,
                HD.hba1c,
                HD.bodyAge,
                HD.glucose,
                HD.cholesterol,
                HD.hdl,
                HD.ldl,
                HD.triglycerides,
                HD.creatinine,
                HD.eGFR,
                HD.uricAcid,
                HD.alt_sgpt,
                HD.alp,
                HD.ast_sgot,

                null foodScore,
                null otherScore,
                null sleepScore,
                null stepScore,
                null waterScore,
                null workoutScore,

                null sleepHours,
                '' startSleepTime,
                '' endSleepTime,

                '' waterVolume,
                
                null steps,
                null run,
                null cycling,
                null meditation,
                null etc,
                null totalWorkout,

                '' menu,
                null serving

            from 
                groupMemberData GM
                join thaisook_view.healthdata HD
                on HD.uid = GM.uid
                    and date(HD.date) between '${startDate}' and '${endDate}' 
            ),
            memberHealthpoint as (
            select 
                date(HP.date) recordDate,
                time(HP.date) recordTime,

                GM.firstname,
                GM.lastname,
                GM.birthdate,
                GM.gender,
                GM.height,
                GM.uid,

                GM.groupId groupId,
                GM.name groupName,
                
                'healthpoint' category,
                CAST(NULL as string) source,

                null pressureUpper,
                null pressureLower,
                null hr,
                null weight,
                null bmi,
                null rightArmFat,
                null leftArmFat,
                null rightLegFat,
                null leftLegFat,
                null trunkFat,
                null bodyFat,
                null visceralFat,
                null muscle,
                null waist,
                null hba1c,
                null bodyAge,
                null glucose,
                null cholesterol,
                null hdl,
                null ldl,
                null triglycerides,
                null creatinine,
                null eGFR,
                null uricAcid,
                null alt_sgpt,
                null alp,
                null ast_sgot,

                HP.foodScore,
                HP.otherScore,
                HP.sleepScore,
                HP.stepScore,
                HP.waterScore,
                HP.workoutScore,

                null sleepHours,
                '' startSleepTime,
                '' endSleepTime,

                '' waterVolume,

                null steps,
                null run,
                null cycling,
                null meditation,
                null etc,
                null totalWorkout,

                '' menu,
                null serving

            from 
                groupMemberData GM
                join activity_view.healthpoint HP
                on HP.uid = GM.uid
                    and date(HP.date) between '${startDate}' and '${endDate}' 
            ),
            memberSleep as (
            select 
                date(SL.date) recordDate,
                time(SL.date) recordTime,

                GM.firstname,
                GM.lastname,
                GM.birthdate,
                GM.gender,
                GM.height,
                GM.uid,

                GM.groupId groupId,
                GM.name groupName,
                
                'sleep' category,
                CAST(NULL as string) source,

                null pressureUpper,
                null pressureLower,
                null hr,
                null weight,
                null bmi,
                null rightArmFat,
                null leftArmFat,
                null rightLegFat,
                null leftLegFat,
                null trunkFat,
                null bodyFat,
                null visceralFat,
                null muscle,
                null waist,
                null hba1c,
                null bodyAge,
                null glucose,
                null cholesterol,
                null hdl,
                null ldl,
                null triglycerides,
                null creatinine,
                null eGFR,
                null uricAcid,
                null alt_sgpt,
                null alp,
                null ast_sgot,

                null foodScore,
                null otherScore,
                null sleepScore,
                null stepScore,
                null waterScore,
                null workoutScore,

                SL.sleepHours,
                SL.startTime startSleepTime,
                SL.endTime endSleepTime,

                '' waterVolume,

                null steps,
                null run,
                null cycling,
                null meditation,
                null etc,
                null totalWorkout,

                '' menu,
                null serving

            from 
                groupMemberData GM
                join activity_view.sleep SL
                on SL.uid = GM.uid
                    and date(SL.date) between '${startDate}' and '${endDate}' 
            ),
            memberWater as (
            select 
                date(WT.date) recordDate,
                time(WT.date) recordTime,

                GM.firstname,
                GM.lastname,
                GM.birthdate,
                GM.gender,
                GM.height,
                GM.uid,

                GM.groupId groupId,
                GM.name groupName,
                
                'water' category,
                CAST(NULL as string) source,

                null pressureUpper,
                null pressureLower,
                null hr,
                null weight,
                null bmi,
                null rightArmFat,
                null leftArmFat,
                null rightLegFat,
                null leftLegFat,
                null trunkFat,
                null bodyFat,
                null visceralFat,
                null muscle,
                null waist,
                null hba1c,
                null bodyAge,
                null glucose,
                null cholesterol,
                null hdl,
                null ldl,
                null triglycerides,
                null creatinine,
                null eGFR,
                null uricAcid,
                null alt_sgpt,
                null alp,
                null ast_sgot,

                null foodScore,
                null otherScore,
                null sleepScore,
                null stepScore,
                null waterScore,
                null workoutScore,

                null sleepHours,
                '' startSleepTime,
                '' endSleepTime,
                
                WT.waterVolume,

                null steps,
                null run,
                null cycling,
                null meditation,
                null etc,
                null totalWorkout,

                '' menu,
                null serving

            from 
                groupMemberData GM
                join activity_view.water WT
                on WT.uid = GM.uid
                    and date(WT.date) between '${startDate}' and '${endDate}' 
            ),
            memberWorkout as (
            select 
                date(WO.date) recordDate,
                time(WO.date) recordTime,

                GM.firstname,
                GM.lastname,
                GM.birthdate,
                GM.gender,
                GM.height,
                GM.uid,

                GM.groupId groupId,
                GM.name groupName,
                
                'workout' category,
                WO.source,

                null pressureUpper,
                null pressureLower,
                null hr,
                null weight,
                null bmi,
                null rightArmFat,
                null leftArmFat,
                null rightLegFat,
                null leftLegFat,
                null trunkFat,
                null bodyFat,
                null visceralFat,
                null muscle,
                null waist,
                null hba1c,
                null bodyAge,
                null glucose,
                null cholesterol,
                null hdl,
                null ldl,
                null triglycerides,
                null creatinine,
                null eGFR,
                null uricAcid,
                null alt_sgpt,
                null alp,
                null ast_sgot,

                null foodScore,
                null otherScore,
                null sleepScore,
                null stepScore,
                null waterScore,
                null workoutScore,

                null sleepHours,
                '' startSleepTime,
                '' endSleepTime,

                '' waterVolume,

                WO.steps,
                WO.run,
                WO.cycling,
                WO.meditation,
                WO.etc,
                WO.totalWorkout,

                '' menu,
                null serving

            from 
                groupMemberData GM
                join activity_view.workout WO
                on WO.uid = GM.uid
                    and date(WO.date) between '${startDate}' and '${endDate}' 
            ),
            memberFood as (
            select 
                date(FD.date) recordDate,
                time(FD.date) recordTime,

                GM.firstname,
                GM.lastname,
                GM.birthdate,
                GM.gender,
                GM.height,
                GM.uid,

                GM.groupId groupId,
                GM.name groupName,
                
                'food' category,
                CAST(NULL as string) source,

                null pressureUpper,
                null pressureLower,
                null hr,
                null weight,
                null bmi,
                null rightArmFat,
                null leftArmFat,
                null rightLegFat,
                null leftLegFat,
                null trunkFat,
                null bodyFat,
                null visceralFat,
                null muscle,
                null waist,
                null hba1c,
                null bodyAge,
                null glucose,
                null cholesterol,
                null hdl,
                null ldl,
                null triglycerides,
                null creatinine,
                null eGFR,
                null uricAcid,
                null alt_sgpt,
                null alp,
                null ast_sgot,

                null foodScore,
                null otherScore,
                null sleepScore,
                null stepScore,
                null waterScore,
                null workoutScore,

                null sleepHours,
                '' startSleepTime,
                '' endSleepTime,

                '' waterVolume,

                null steps,
                null run,
                null cycling,
                null meditation,
                null etc,
                null totalWorkout,

                FD.menu,
                FD.serving

            from 
                groupMemberData GM
                join activity_view.food FD
                on FD.uid = GM.uid
                    and date(FD.date) between '${startDate}' and '${endDate}' 
            ),
            allData as (
                select * from memberHealthdata
                UNION ALL
                select * from memberWorkout
                UNION ALL
                select * from memberSleep
                UNION ALL
                select * from memberHealthpoint
                UNION ALL
                select * from memberWater
                UNION ALL
                select * from memberFood
            )
            select * from allData order by recordDate, recordTime
        )
    `
    });
    const resultData = JSON.parse(result.data);
    
    if (resultData.errors) {
        console.log(resultData.errors);
    }
    else{
        for( let i = 0; i < 5; i++ ){
            await wait(3000);
            const isFileExist = await toCheckFile(groupId, uid);
            if( isFileExist ){
                return await toDownloadFile(groupId, uid);
            }
        }
    }
}

const wait = async (delay) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, delay)
    })
}

const toDownloadFile = async (id, uid) => {
    const storage = firebase.app().storage("gs://thaisook_bigquery_export");
    const storageRef = storage.ref();
    let downloadFile = `group-${id}-000000000000.csv`;
    if( uid != undefined ){
        downloadFile = `group-${id}-${uid}-000000000000.csv`;
    }
    try {
        // Replace this with your actual file checking logic
        const fileRef = await storageRef.child(downloadFile).getDownloadURL();
        if (fileRef) {
            return fileRef;
        } else {
            return false;
        }
    } catch (error) {
        console.error("Error checking file:", error);
        return false;
    }
}

const toCheckFile = async (id, uid) => {
    const storage = firebase.app().storage("gs://thaisook_bigquery_export");
    const storageRef = storage.ref();
    let checkFile = `group-${id}-000000000000.bom_added`;
    if( uid != undefined ){
        checkFile = `group-${id}-${uid}-000000000000.bom_added`;
    }

    try {
        // Replace this with your actual file checking logic
        const fileRef = await storageRef.child(checkFile).getDownloadURL();
        if (fileRef) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error("Error checking file:", error);
        return false;
    }
}

export default bqExportData;